import * as React from 'react';

type Props = {
    mainContentHeight: number;
    children: React.ReactNode;
};

export function FilterDrawerEntityListWrapper(props: Props) {
    return (
        <div style={{position: 'relative', height: props.mainContentHeight, overflow: 'hidden'}}>
            {props.children}
        </div>
    );
}
